import { ReportsMetadata, RecordsType } from '../../shared/types/shared.types';

export interface TroubleReportAssessmentInterface {
  document_metadata?: ReportsMetadata;
  nir_corrected_limitations?: RecordsType[];
  kll_known_limitations?: RecordsType[];
  kll_corrected_limitations?: RecordsType[];
}

export const CorrectedLimitationsColumns = [
  { attribute: 'release', title: 'Release', sortable: true },
  { attribute: 'technology', title: 'Technology', sortable: true },
  { attribute: 'correction_title', title: 'Correction Title', sortable: true },
  { attribute: 'description_of_correction', title: 'Description of correction', sortable: true },
  { attribute: 'faj_number', title: 'FAJ Number', sortable: true },
  { attribute: 'cxc', title: 'CXC', sortable: true },
  { attribute: 'value_package', title: 'Value Package', sortable: true },
  { attribute: 'vp_faj', title: 'VP FAJ', sortable: true },
  { attribute: 'impact_at_upgrade', title: 'Impact Upgrade', sortable: true },
  { attribute: 'impact_type', title: 'Impact Type', sortable: true },
  { attribute: 'format_type', title: 'Format Type', sortable: true },
  { attribute: 'cm_impact', title: 'CM Impact', sortable: true },
  { attribute: 'new_alarms', title: 'New Alarms', sortable: true },
  { attribute: 'kpi_deviations', title: 'KPI Deviations', sortable: true }
];

export const CorrectedLimitationsFilters = [
  { attribute: 'search', name: 'search', title: 'Global Search', label: 'Search all columns', type: 'input' },
  { attribute: 'release', name: 'fromRelease', title: 'From Release', label: 'Earliest', type: 'select' },
  { attribute: 'release', name: 'toRelease', title: 'To Release', label: 'Latest', type: 'select' },
  { attribute: 'technology', name: 'technology', title: 'Technology', label: 'All', type: 'select' },
  { attribute: 'impact_type', name: 'impactType', title: 'Impact Type', label: 'All', type: 'select' },
  { attribute: 'impact_at_upgrade', name: 'impactAtUpgrade', title: 'Impact at Upgrade', label: 'All', type: 'select' },
  { attribute: 'cm_impact', name: 'hasCmImpact', title: 'CM Impact', label: 'All', type: 'select' },
  { attribute: 'new_alarms', name: 'hasNewAlarms', title: 'New Alarms', label: 'All', type: 'select' },
  { attribute: 'kpi_deviations', name: 'hasKpiDeviations', title: 'KPI Deviations', label: 'All', type: 'select' }
];

export const CorrectedLimitationsDialogMetadata = [
  { attribute: 'metadata.feature_name', title: 'Feature Name' },
  { attribute: 'faj_number', title: 'FAJ Number' },
  { attribute: 'value_package', title: 'Value Package' },
  { attribute: 'vp_faj', title: 'VP FAJ' },
  { attribute: 'technology', title: 'Technology' },
  { attribute: 'impact_at_upgrade', title: 'Impact at Upgrade' }
];

export const CorrectedLimitationsDialogImpactAssessment = [
  { attribute: 'impact_type', title: 'Impact Type' },
  { attribute: 'faj_number', title: 'FAJ Number' },
  { attribute: 'cxc', title: 'CXC' }
];

export const KllKnownLimitationsColumns = [
  { attribute: 'tr_id', title: 'TR id', sortable: true },
  { attribute: 'tr_issued_for', title: 'TR Issued for', sortable: true },
  { attribute: 'description', title: 'Description', sortable: true },
  { attribute: 'observation_summary', title: 'Observation Summary', sortable: true },
  { attribute: 'solution_summary', title: 'Solution Summary', sortable: true },
  { attribute: 'impact_hardware', title: 'Impact Hardware', sortable: true },
  { attribute: 'fault_type', title: 'Fault Type', sortable: true },
  { attribute: 'workaround', title: 'Workaround', sortable: true },
  { attribute: 'technology', title: 'Technology', sortable: true },
  { attribute: 'impacted_area', title: 'Impacted Area', sortable: true }
];

export const KllKnownLimitationsFilters = [
  { attribute: 'search', name: 'search', title: 'Global Search', label: 'Search all columns', type: 'input' },
  { attribute: 'tr_issued_for', name: 'trIssuedFor', title: 'TR Issued For', label: 'All', type: 'select' },
  { attribute: 'technology', name: 'technology', title: 'Technology', label: 'All', type: 'select' },
  { attribute: 'fault_type', name: 'faultType', title: 'Fault Type', label: 'All', type: 'select' }
];

export const KllCorrectedLimitationsColumns = [
  { attribute: 'tr_id', title: 'TR id', sortable: true },
  { attribute: 'tr_issued_for', title: 'TR Issued for', sortable: true },
  { attribute: 'solution_delivered_in', title: 'Solution delivered in', sortable: true },
  { attribute: 'description', title: 'Description', sortable: true },
  { attribute: 'observation_summary', title: 'Observation Summary', sortable: true },
  { attribute: 'solution_summary', title: 'Solution Summary', sortable: true },
  { attribute: 'impact_hardware', title: 'Impact Hardware', sortable: true },
  { attribute: 'sw_feature_faj', title: 'SW Feature FAJ', sortable: true },
  { attribute: 'technology', title: 'Technology', sortable: true },
  { attribute: 'impacted_area', title: 'Impacted Area', sortable: true },
  { attribute: 'solution_area', title: 'Solution Area', sortable: true }
];

export const KllCorrectedLimitationsFilters = [
  { attribute: 'search', name: 'search', title: 'Global Search', label: 'Search all columns', type: 'input' },
  { attribute: 'tr_issued_for', name: 'trIssuedFor', title: 'TR Issued For', label: 'All', type: 'select' },
  { attribute: 'solution_delivered_in', name: 'solutionDeliveredIn', title: 'Solution Delivered In', label: 'All', type: 'select' },
  { attribute: 'technology', name: 'technology', title: 'Technology', label: 'All', type: 'select' },
  { attribute: 'fault_type', name: 'faultType', title: 'Fault Type', label: 'All', type: 'select' }
];

export const KllKnownLimitationsDialogMetadata = [
  { attribute: 'tr_id', title: 'TR ID' },
  { attribute: 'tr_issued_for', title: 'TR Issued For' },
  { attribute: 'technology', title: 'Technology' },
  { attribute: 'fault_type', title: 'Fault Type' },
  { attribute: 'impacted_area', title: 'Impacted Area' }
];

export const KllKnownLimitationsDialogImpactAssessment = [
  { attribute: 'impact_hardware', title: 'Impact Hardware' },
  { attribute: 'workaround', title: 'Workaround' }
];

export const KllCorrectedLimitationsDialogMetadata = [
  { attribute: 'tr_id', title: 'TR ID' },
  { attribute: 'tr_issued_for', title: 'TR Issued For' },
  { attribute: 'solution_delivered_in', title: 'Solution Delivered In' },
  { attribute: 'technology', title: 'Technology' },
  { attribute: 'impacted_area', title: 'Impacted Area' },
  { attribute: 'solution_area', title: 'Solution Area' }
];

export const KllCorrectedLimitationsDialogImpactAssessment = [
  { attribute: 'impact_hardware', title: 'Impact Hardware' },
  { attribute: 'sw_feature_faj', title: 'SW Feature FAJ' }
];
